import React,{useState} from 'react';
import Auxiliary from '../../util/Auxiliary';
import { Button, Card, Col, Form, Input, Row, Select, message} from 'antd';
import { Link } from 'react-router-dom';
import axios from '../../util/Api';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const Create = (props) => {
  const { history } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false); //set true when submitting form
  
  const onFinish = (values) => {
    setLoading(true);
    const url = `/vendor/create`;
    const data = { ...values };
    axios.post(url, data).then(({ data }) => {
      setLoading(false);
      if (data.success) {
        message.success("Vendor baru telah berhasil dibuat",5);
        history.push(`/vendor/detail?id=${data.id}`);
      } else {
        message.error("Gagal menyimpan data vendor baru");
      }
    }).catch(err => {
      setLoading(false);
      const resp = err.response;
      message.error(resp.data.message,5);
    });
  }
  return (
    <Auxiliary>
      <h1 className="title gx-mb-4">Registrasi Perusahaan Baru</h1>
      <Row>
        <Col xs={24} sm={24} md={24} lg={16}>

          <Card className="gx-card" title="Form Registrasi">
            <Form
              {...layout}
              form={form}
              name="vendor-registration"
              onFinish={onFinish}
              initialValues={{
                
              }}
              scrollToFirstError
            >
              <Form.Item
                name="name"
                label={
                  <span>
                    Nama Perusahaan
                  </span>
                }
                rules={[{ required: true, message: 'Nama perusahaan wajib diisi', whitespace: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="code"
                label="Kode Vendor"
                rules={[{ required: true, message: "Kode perusahaan wajib diisi", whitespace: true }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="category"
                label="Kategori"
                rules={[{ required: true, message: "Kategori perusahaan wajib diisi", whitespace: true }]}
              >
                <Select
                  placeholder="Pilih kategori perusahaan"
                  onChange={(value) => form.setFieldsValue({ category: value })}
                  allowClear
                >
                  <Select.Option value="1">Z</Select.Option>
                  <Select.Option value="2">Non Z</Select.Option>
                  <Select.Option value="3">PP</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="type"
                label="Jenis Perusahaan"
                rules={[{ required: true, message: "Jenis perusahaan wajib diisi", whitespace: true }]}
              >
                <Select
                  placeholder="Pilih jenis perusahaan"
                  onChange={(value) => form.setFieldsValue({ type: value })}
                  allowClear
                >
                  <Select.Option value="1">Subkon</Select.Option>
                  <Select.Option value="2">Supplier</Select.Option>
                  <Select.Option value="3">Alat</Select.Option>
                  <Select.Option value="4">Lainnya</Select.Option>
                  <Select.Option value="5">PP</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="division"
                label="Divisi Perusahaaan"
                rules={[{ required: true, message: "Divisi perusahaan wajib diisi", whitespace: true }]}
              >
                <Select
                  placeholder="Pilih divisi perusahaan"
                  onChange={(value) => form.setFieldsValue({ division: value })}
                  allowClear
                >
                  <Select.Option value="1">EPC</Select.Option>
                  <Select.Option value="2">Gedung</Select.Option>
                  <Select.Option value="3">Infra 1</Select.Option>
                  <Select.Option value="4">Infra 2</Select.Option>
                  <Select.Option value="5">PP</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="email"
                label="E-mail"
                rules={[
                  {
                    type: 'email',
                    message: 'Email tidak valid',
                  },
                  {
                    required: true,
                    message: 'Email wajib diisi',
                    whitespace: true
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    message: 'Password perusahaan wajib diisi',
                  },
                  {
                    min: 6,
                    message: "Password minimal 6 karakter"
                  }
                ]}
                hasFeedback
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                name="phone"
                label="Nomor Telepon/WA"
                rules={[
                  {
                    required: true,
                    message: 'Nomort telepon/WA wajib diisi',
                    whitespace: true
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Row>
                <Col span={8}></Col>
                <Col span={16}>
                  <Button type="primary" htmlType="submit" className="gx-mb-0" loading={loading}>
                    Daftarkan Perusahaan
                  </Button>
                  <Link to="/vendor" className="ant-btn ant-btn-secondary gx-mb-0">
                    Kembali
                  </Link>
                </Col>
              </Row>

            </Form>
          </Card>
          
        </Col>
      </Row>
    </Auxiliary>
  );
}

export default Create;